const reports =
{
    headers: {
        'Summary': 'Podsumowanie',
        'RequestParameters': 'Parametry żądania',
        'RuntimeParameters': 'Parametry wykonania',
        'Configuration': 'Konfiguracja',
        'GlobalErrorDetails': 'Szczegóły błędu globalnego',
        'Records': 'Dane',
        "Id": "Id",
        "Type": "Typ",
        "Created": "Utworzono",
        "Report List": "Lista raportów",
    },
    summary: {
        "Global Status": "Status globalny",
        "Records - Total": "Rekordy - Liczba",
        "Records - Invalid": "Rekordy - Rozpoznane jako nieprawidłowe",
        "Records - With Errors": "Rekordy - Z błędami",
        "Records - Created": 'Rekordy - Utworzone',
        "Records - Updated": 'Rekordy - Zaktualizowane',
        "Validation - Parent - Without": "Walidacja - Rodzic - Prawidłowe - Brak",
        "Validation - Parent - Found": "Walidacja - Rodzic - Prawidłowy - Znaleziony",
        "Validation - Parent - Not Found": "Walidacja - Rodzic - Nieprawidłowe - Nie znaleziony",
        "Validation - Image - Without": "Walidacja - Obraz - Prawidłowe - Brak",
        "Validation - Image - Found": "Walidacja - Obraz - Prawidłowe - Znaleziony",
        "Validation - Image - Not Found": "Walidacja - Obraz - Nieprawidłowe - Nie znaleziony",
        "Validation - Tree - Consistent": "Walidacja - Drzewo - Spójne",
        "Validation - Tree - Orphaned": "Walidacja - Drzewo - Osierocone",
        "Validation - Tree - Valid": "Walidacja - Drzewo - Prawidłowe",
        "Validation - Tree - Invalid - Total": "Walidacja - Drzewo - Nieprawidłowe - Łącznie",
        "Validation - Tree - Invalid - Orphaned": "Walidacja - Drzewo - Nieprawidłowe - Osierocone",
        "Validation - Tree - Invalid - ExternalIdConflict": "Walidacja - Drzewo - Nieprawidłowe - Konflikt ExternalId",
        "Validation - Category - Valid - Total": "Walidacja - Kategoria - Prawidłowe",
        "Validation - Category - Valid - With Category": "Walidacja - Kategoria - Prawidłowe - Z kategorią",
        "Validation - Category - Valid - Without Category": "Walidacja - Kategoria - Prawidłowe - Bez kategorii",
        "Validation - Category - Invalid - Not Found": "Walidacja - Kategoria - Nieprawidłowe - Nie znaleziona",
        "Validation - Country - Valid - Total": "Walidacja - Kraj - Prawidłowe",
        "Validation - Country - Valid - With Country": "Walidacja - Kraj - Prawidłowe - Z krajem",
        "Validation - Country - Valid - Without Country": "Walidacja - Kraj - Prawidłowe - Bez kraju",
        "Validation - Country - Invalid - Not Found": "Walidacja - Kraj - Nieprawidłowe - Nie znaleziony",
        "Validation - Manufacturer - Valid - Total": "Walidacja - Producent - Prawidłowe",
        "Validation - Manufacturer - Valid - With Manufacturer": "Walidacja - Producent - Prawidłowe - Z producentem",
        "Validation - Manufacturer - Valid - Without Manufacturer": "Walidacja - Producent - Prawidłowe - Bez producenta",
        "Validation - Manufacturer - Invalid - Not Found": "Walidacja - Producent - Nieprawidłowe - Nie znaleziony",
        "Validation - Measure - Valid - Total": "Walidacja - Miara - Prawidłowe",
        "Validation - Measure - Valid - With Measure": "Walidacja - Miara - Prawidłowe - Z miarą",
        "Validation - Measure - Valid - Without Measure": "Walidacja - Miara - Prawidłowe - Bez miary",
        "Validation - Measure - Invalid - Not Found": "Walidacja - Miara - Nieprawidłowe - Nie znaleziona",
    },
    messages: {
        "Completed without global errors": "Zakończono bez błędów globalnych",
    },
    types: {
        "synchronization:categories": "Synchronizacja kategorii",
        "synchronization:products": "Synchronizacja produktów",
        "synchronization:product-translation": "Synchronizacja tłumaczeń produktów",
        "synchronization:category-translation": "Synchronizacja tłumaczeń kategorii",
    }
};
export default reports;